

































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { SysKBMediaModule } from '@/store/modules/sysKBMedia';
import MediaUploadDialog from '@/components/KnowledgeBase/MediaUploadDialog.vue';
import KBMediaListItem from '@/models/KnowledgeBase/KBMediaListItem';
import KBMediaType from '@/models/KnowledgeBase/KBMediaType';

@Component({
  name: 'MediaSelectorDialog',
  components: {
    MediaUploadDialog
  }
})
export default class MediaSelectorDialog extends Vue {
  @Prop({ required: true })
  public dialog!: boolean;

  private searchTerm = '';
  private mediaTypeFilter: number | null = 1; // Default to images
  private currentPage = 1;
  private limit = 20;
  private selectedMediaId = '';
  private uploadDialog = false;
  private searchDebounceTimer: number | null = null;

  private mediaTypeOptions = [
    { text: 'All Types', value: null },
    { text: 'Images', value: KBMediaType.Image },
    { text: 'Videos', value: KBMediaType.Video },
    { text: 'Files', value: KBMediaType.File }
  ];

  get internalDialog(): boolean {
    return this.dialog;
  }

  set internalDialog(value: boolean) {
    if (!value) {
      this.$emit('close');
    }
  }

  get loading(): boolean {
    return SysKBMediaModule.loadingMediaList;
  }

  get mediaList() {
    return SysKBMediaModule.mediaList;
  }

  get mediaItems(): KBMediaListItem[] {
    return this.mediaList?.items || [];
  }

  get totalPages(): number {
    if (!this.mediaList) return 0;
    return Math.ceil(this.mediaList.total / this.limit);
  }

  get offset(): number {
    return (this.currentPage - 1) * this.limit;
  }

  @Watch('dialog')
  onDialogChange(newVal: boolean) {
    if (newVal) {
      this.loadMediaList();
      this.selectedMediaId = '';
    }
  }

  debouncedSearch() {
    if (this.searchDebounceTimer) {
      clearTimeout(this.searchDebounceTimer);
    }
    this.searchDebounceTimer = window.setTimeout(() => {
      this.currentPage = 1;
      this.loadMediaList();
    }, 300);
  }

  async loadMediaList() {
    const params: any = {
      limit: this.limit,
      offset: this.offset
    };

    if (this.searchTerm) {
      params.searchTerm = this.searchTerm;
    }
    if (this.mediaTypeFilter !== null) {
      params.mediaType = this.mediaTypeFilter;
    }

    await SysKBMediaModule.getMediaList(params);
  }

  onPageChange() {
    this.loadMediaList();
  }

  selectMedia(media: KBMediaListItem) {
    this.selectedMediaId = media.id;
  }

  insertMedia() {
    if (!this.selectedMediaId) return;

    const media = this.mediaItems.find(m => m.id === this.selectedMediaId);
    if (!media) return;

    // Use displayUrl for images (optimized for KB display), mediaUrl for other types
    const urlToUse = media.mediaType === KBMediaType.Image ? media.displayUrl : media.mediaUrl;

    this.$emit('select', {
      id: media.id,
      fileName: media.originalFileName,
      altText: media.altText || media.originalFileName,
      mediaType: media.mediaType,
      mediaUrl: urlToUse,
      originalUrl: media.mediaUrl  // Keep original for click-to-enlarge functionality
    });

    this.close();
  }

  openUploadDialog() {
    this.uploadDialog = true;
  }

  async onMediaUploaded(mediaId: string) {
    await this.loadMediaList();
    this.selectedMediaId = mediaId;
  }

  close() {
    this.selectedMediaId = '';
    this.internalDialog = false;
  }
}
